module.exports = __webpack_public_path__ + "static/media/sad_icon.6b9cc032.png";